export const editMediaSettings = {
  success: true,
  userID: 2,
  //   VIDEO
  type: "video",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",

  //   IMAGE
  // type: "image",
  // imageUrl: "https://placehold.co/600x360",
  // photoID: 123,
};
